import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { UpdateListSortGeoPaymentMethodRequestPayload } from '@/models/ps-management/ps-management.model';

export default class UpdateListSortGeoPaymentMethodRequest
  extends ApiResourceMethod<{}> {
  public perform(payload: UpdateListSortGeoPaymentMethodRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${payload.countryCode}/sorting`,
        data: payload.payloadData,
      },
      (response: BaseResponse<{}>) => {
        return response.data;
      },
    );
  }
}
